import { createContext, useContext } from 'react'
import { TransferMethod } from '../../types/transferMethod'

export const UserContext = createContext({
    authenticatedUser: undefined,
    transferMethods: [],
    upcomingPayment: {},
    setAuthenticatedUser: (user: any) => {
        console.error('Context not implemented')
    },
    setTransferMethods: (transferMethods: TransferMethod[]) => {
        console.error('Context not implemented')
    },
    setUpcomingPayment: (upcomingPayment: any) => {
        console.error('Context not implemented')
    },
})
UserContext.displayName = 'UserContext'

export const useAuthenticatedUser = () => useContext(UserContext)
